import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { SharedPipesModule } from '../../../../shared/pipes/shared-pipes.module';
import { SharedModule } from '../../../../shared/shared.module';
import { TitleRegistrationService } from '../../../services/titleregistration.service';
import { RegistrationSearchComponent } from './registration-search.component';

@NgModule({
    declarations: [
        RegistrationSearchComponent
    ],
    providers: [
        TitleRegistrationService
    ],
    exports: [
        RegistrationSearchComponent
    ],
    imports: [
        SharedModule,
        SharedPipesModule,
        TableModule
    ]
})
export class RegistrationSearchModule {
}
